import * as Factory from 'factory.ts'
import faker from 'faker'

import { PayRequestAction } from '@webapp/models/PayRequestAction'
import { type PayRequestLog } from '@webapp/models/PayRequestLog'
import { UserMock } from './user.factory'

export const PayRequestLogMock = Factory.Sync.makeFactory<PayRequestLog>({
  id: Factory.each(() => faker.random.number()),
  user: UserMock.build(),
  action: Factory.each(() =>
    faker.random.number({
      min: PayRequestAction.REQUESTED,
      max: PayRequestAction.DELETED,
    })
  ),
  dateTime: Factory.each(() => faker.date.past(10).toISOString()),
  requester: UserMock.build(),
  next_approver: UserMock.build(),
  approval_delegatee: null,
})
